import React from "react"

import { AppIconChipToggle } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportGenerateSwitch() {
	const {
		generate,
		setGenerateInfo,
	} = useReportFormInfo(reportFormData.peek().generate, "generate", object({ generate: boolean() }))

	return <AppIconChipToggle
		aria-label="Generate"
		value={!!generate}
		options={[
			{ value: false, label: "Don't generate", icon: 'ban' },
			{ value: true, label: 'Generate', icon: 'file-export' },
		]}
		onChange={value => setGenerateInfo(value)}
	/>
}